





















// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import * as Platform from "@/platform";

const getImages = (platform:string) => {
	return [1,2].map(v => `/img/fb/${platform}/${v}.png`);
};

export default defineComponent({

	emits:[],
	props:{
	},
	components:{
	},
	setup(){
		
		const images = computed(() => {
			return getImages(platform.value);
		});
		
		const platform = computed(() => {
			if(Platform.isIOS()){ return "ios"; }
			return "android";
		});

		return {
			images
		};
	}
});

